import React from 'react';
import LtaCams from '../components/lta_cams';
function Cams(){
    return(  
        <LtaCams/>
    )
}
export default Cams;